var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role_tree"},_vm._l((_vm.menuList),function(node){return _c('tree-node',{key:node.id,attrs:{"roleMap":_vm.menuMap,"readonly":_vm.readonly,"nodeData":node,"treeNodeProps":{
            key: 'id',
            name: 'name',
            children: 'children',
            parentId:'pid'
        }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }